export const environment = {
  production: true,
  host: 'https://api-devupt.angolaencontra.com',
  googleClientId: '335990291064-fv1jeg2vfd9rfmrspqnl7icra8l9vul6.apps.googleusercontent.com',

  social: {
    facebook: "https://www.facebook.com/profile.php?id=61570986230322",
    instagram: "https://www.instagram.com/angolaencontra/",
    linkedIn: "https://www.linkedin.com/company/angolaencontra"
  }
};
